import { Autocomplete, Box, FormControl, Hidden, IconButton, TextField, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import StatusComponent from "../../../../../../components/status"
import { getStatus } from "../../../../../../hooks/status"
import { useContextState } from "../../../../../../hooks/theme"
import { icons } from "../../../../../../utils/icons"
import { KeyValue } from "../keyValue"
import { useStyles } from "./styles"
import { VisitProps } from "./type"
import { Status } from "../../../../../../utils/enums"

const Visite = ({
    seeDetail,
    children,
    visitList,
    detail,
    title,
    id,
    status,
    dateEnd,
    dateStart,
    programedType,
    questonCompleted,
    result,
    sectionCompleted,
    detailVersion,
    showchildren,
    isStore
}: VisitProps) => {

    const areThereVisitList = (visitList?.length || 0) > 1
    const { t } = useTranslation()
    const { colors } = useContextState()
    const statusLocale = getStatus((status == Status.CLOSE && isStore) ? Status.CANCEL : status, colors, t)
    const styles = useStyles({ detail: !!detail })
    const openDetail = () => {
        if (seeDetail) {
            seeDetail({ id })
        }
    }
    const reloadDetail = (event: React.ChangeEvent<{}>, newValue: string | null) => {
        if (newValue && seeDetail) {
            seeDetail({ id: newValue });
        }
    };

    return (
        <CustomPaper sx={styles.container}>
            <Box sx={styles.containerInfo}>
                <Box sx={styles.title}>
                    {!detail && (
                        <Box sx={styles.version}>
                            <Typography variant="subtitle" fontWeight='bold'>{title}</Typography>

                            {!!detailVersion && <Typography variant="footer" fontWeight='500'>#{detailVersion?.parentId} - {t('general.tags.version')}: {detailVersion?.version}</Typography>}
                        </Box>
                    )}

                    {!!detail && (
                        <>
                            {!areThereVisitList && (
                                <Box sx={styles.version}>
                                    <Typography variant="subtitle" fontWeight='bold'>{title}</Typography>

                                    {!!detailVersion && <Typography variant="footer" fontWeight='500'>#{detailVersion?.parentId} - {t('general.tags.version')}: {detailVersion?.version}</Typography>}
                                </Box>
                            )}
                            {areThereVisitList && (
                                <Box>
                                    <Box><Typography variant="subtitle" fontWeight='bold'>{title}</Typography></Box>
                                    <FormControl sx={styles.formControl}>
                                        <Autocomplete
                                            value={visitList?.find(visit => visit.id === id) || null}
                                            onChange={(event, newValue) => reloadDetail(event, newValue ? newValue.id : null)}
                                            options={visitList || []}
                                            getOptionLabel={(option) => option.dateStart}
                                            renderInput={(params) => <TextField {...params} sx={styles.titleAutocomplete}/* label={title}  */ />}
                                            clearIcon={null}
                                        />
                                    </FormControl>
                                </Box>
                            )}
                        </>
                    )}

                    <Hidden lgUp>
                        {!detail && (
                            <StatusComponent size="small" color={statusLocale.color} msg={statusLocale.text} />
                        )
                        }
                    </Hidden>
                </Box>

                <Hidden lgUp>
                    {!detail && (
                        <IconButton onClick={openDetail} sx={styles.search}><Tooltip title={'Ver detalle'}>{icons('visibility')}</Tooltip></IconButton>
                    )
                    }
                    {((!!detail || !!showchildren) && children) && children}
                </Hidden>

                {
                    !detail && (
                        <>
                            <Box sx={[styles.content, styles.separator]}>
                                <KeyValue caption="Resultado obtenido" value={result} />
                                <KeyValue caption="Preguntas completadas" value={questonCompleted} />
                                <KeyValue caption="Secciones completadas" value={sectionCompleted} />
                            </Box>

                            <Box sx={styles.content}>
                                <KeyValue caption="Tipo de programación" value={programedType} />
                                <KeyValue caption="Fecha de inicio" value={dateStart} />
                                <KeyValue caption="Fecha de fin" value={dateEnd} />
                            </Box>
                        </>
                    )
                }

                {!!detail && (
                    <Box sx={styles.description}>
                        <Box sx={[styles.content, styles.separator]}>
                            <KeyValue caption="Resultado obtenido" value={result} />
                            <KeyValue caption="Preguntas completadas" value={questonCompleted} />
                            <KeyValue caption="Secciones completadas" value={sectionCompleted} />
                        </Box>

                        <Box sx={styles.content}>
                            <KeyValue caption="Tipo de programación" value={programedType} />
                            <KeyValue caption="Fecha de inicio" value={dateStart} />
                            <KeyValue caption="Fecha de fin" value={dateEnd} />
                        </Box>
                    </Box>
                )}
            </Box>

            <Hidden lgDown>
                {!detail && (
                    <>
                        <Box sx={[styles.content, styles.status]}>
                            <StatusComponent size="small" color={statusLocale.color} msg={statusLocale.text} />
                        </Box>
                        <IconButton onClick={openDetail} sx={styles.search}><Tooltip title={'Ver detalle'}>{icons('visibility')}</Tooltip></IconButton>
                    </>
                )}
                {((!!detail || !!showchildren) && children) && children}
            </Hidden>
        </CustomPaper>
    )
}

export default Visite